import {I_ACCESS_TOKEN_PARAMS,I_COMMON_DELETE_PARAMS,I_COMMON_GET_ITEM_PARAMS,_customFetch, getFetchDELETEOptions, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- ACTIVITIES
// ---------------------------------

const ENDPOINT_ACTIVITIES = '/activities';

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  from_date: string;
  to_date: string;
  activity_types: string;
  directions_ops: string;  // direction de la charge
  hubs_ops: string;  // pole de direction de la charge
  directions_hr: string;  // direction de l'activité de la charge
  hubs_hr: string;  // pole de direction de l'activité de la charge
  collaborators: string;
  skills: string;
  functions: string;
  billing_customers: string;
  audited_customers: string;
  referentials: string;
  referential_types: string;
  of_number: string;
}
interface I_EXPORT_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  from_date: string;
  to_date: string;
  activity_types: string;
  directions_ops: string;  // direction de la charge
  hubs_ops: string;  // pole de direction de la charge
  directions_hr: string;  // direction de l'activité de la charge
  hubs_hr: string;  // pole de direction de l'activité de la charge
  collaborators: string;
  skills: string;
  functions: string;
  billing_customers: string;
  audited_customers: string;
  referentials: string;
  referential_types: string;
  of_number: string;
  file_type: string;  // csv ou  xls
  file_format: string;  // encoding utf-8
}
/**
 * Requete le endpoint activities
 * Récupère la liste des activites
 * @param param0
 */
const get = async ({
  accessToken,page,
  from_date,to_date,activity_types,
  directions_ops,hubs_ops,directions_hr,hubs_hr,
  collaborators,skills,functions,billing_customers,
  audited_customers,
  referentials,
  referential_types,
  of_number,
}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - activities - get...'));
  const options = getFetchGETOptions({accessToken});
  const paramPage = `${page ? '&page=' + page : ''}`;
  const paramFromDate = `from_date=${from_date}`;
  const paramToDate = `to_date=${to_date}`;
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirectionsOps = directions_ops ? `directions_ops=${directions_ops}` : '';
  const paramHubsOps = hubs_ops ? `hubs_ops=${hubs_ops}` : '';
  const paramDirectionsHr = directions_hr ? `directions_hr=${directions_hr}` : '';
  const paramHubsHr = hubs_hr ? `hubs_hr=${hubs_hr}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramBillingCustomers = billing_customers ? `billing_customers=${billing_customers}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramsAll = [
    paramFromDate,
    paramToDate,
    paramActivityTypes,
    paramDirectionsOps,
    paramHubsOps,
    paramDirectionsHr,
    paramHubsHr,
    paramCollaborators,
    paramSkills,
    paramFunctions,
    paramBillingCustomers,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,
  ].join('&');
  const URL = `${ENDPOINT_ACTIVITIES}${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}${paramPage}`;
  return _customFetch(URL,options);
};


/**
 * Requete le endpoint activities
 * Récupère l'activite
 * @param param0
 * @returns
 */
const getItem = async ({accessToken,id}:I_COMMON_GET_ITEM_PARAMS) => {
  logger.trace(...formatTrace('ApiEndpoints - activities - getItem...'));
  const options = getFetchGETOptions({accessToken});
  const URL = `${ENDPOINT_ACTIVITIES}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

interface I_ACTIVITY_POST_PARAMS {
  accessToken: string,

  model?: boolean;
  id_model?: number;  // uniquement si model = true

  name: string;
  description?: string;

  collaborator_id: number | null; // FK Collaborateur
  skills_id: number[]; //FK compétences il peut y en avoir plusieurs
  mode_volume: 'hour' | 'percent' | '';  // definit la facon dont on rentre les heures (hour | percent)
  value_volume?: number; // valeur pour heures (!! peut etre null poour la creation d'un model)
  /** id du type d'activité de l'activité (opt.) */
  activity_type_id?: number;

  from_date?: string;  //obligatoire si model==false
  to_date?: string;  //obligatoire si model==false
  direction?: string;  //obligatoire si model==false
  hub?: string; // sous-direction (pole)
  site_customer_id?: number;  // site d'intervention, parrmi les sites créés pour le referential customer de la charge
  audit_date?: string;
  audit_start_date?: string;
  audit_end_date?: string;
  funct: string;
  provisional?: boolean;
}
/**
 * Requete le endpoint activities
 * Ajoute une activite
 * @param param0
 * @returns
 */
export const post = async ({
  accessToken,
  model,id_model,
  name,description,
  direction,hub,
  from_date,to_date,
  collaborator_id,
  skills_id,
  mode_volume,
  value_volume,
  site_customer_id,
  audit_date,
  audit_start_date,
  audit_end_date,
  funct,
  provisional,
}:I_ACTIVITY_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - activities - post...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description?.trim() || ''),
      direction: direction ? encodeURIComponent(direction) : undefined,
      hub: hub ? encodeURIComponent(hub) : undefined,
      from_date,
      to_date,

      model,
      id_model,

      collaborator_id,
      skills_id,
      mode_volume,
      value_volume,
      site_customer_id,
      audit_date,
      audit_start_date,
      audit_end_date,
      function: funct,
      provisional,
    })
  };
  const URL = ENDPOINT_ACTIVITIES + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint activities
 * Supprime une activité
 * @param param0
 * @returns
 */
const remove = async ({accessToken,id}:I_COMMON_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - activities - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_ACTIVITIES}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

interface I_CHARGE_PUT_PARAMS {
  accessToken: string,
  id: number,

  model?: boolean;
  id_model?: number;  // uniquement si model = true

  name: string;
  description?: string;

  collaborator_id: number | null; // FK Collaborateur
  skills_id: number[]; //FK compétences il peut y en avoir plusieurs
  mode_volume: 'hour' | 'percent' | '';  // definit la facon dont on rentre les heures (hour | percent)
  value_volume?: number; // valeur pour heures (!! peut etre null poour la creation d'un model)
  /** id du type d'activité de l'activité (opt.) */
  activity_type_id?: number;

  from_date?: string;  //obligatoire si model==false
  to_date?: string;  //obligatoire si model==false
  direction?: string;  //obligatoire si model==false
  hub?: string; // sous-direction (pole)
  site_customer_id?: number;  // site d'intervention, parrmi les sites créés pour le referential customer de la charge
  audit_date?: string;
  audit_start_date?: string;
  audit_end_date?: string;
  funct: string;
  provisional?: boolean;
}
/**
 * Requete le endpoint activities
 * Met à jour une activité
 * @param param0
 * @returns
 */
const put = async ({
  accessToken,id,
  name,description,
  direction,hub,
  from_date,to_date,
  collaborator_id,
  skills_id,
  mode_volume,
  value_volume,
  site_customer_id,
  audit_date,
  audit_start_date,
  audit_end_date,
  funct,
  provisional,
  activity_type_id
}:I_CHARGE_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - activities - put...'));
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description?.trim() || ''),
      direction: direction ? encodeURIComponent(direction) : undefined,
      hub: hub ? encodeURIComponent(hub) : undefined,
      from_date,to_date,

      collaborator_id,
      skills_id,
      mode_volume,
      value_volume,
      site_customer_id,
      audit_date,
      audit_start_date,
      audit_end_date,
      function: funct,
      provisional,
      activity_type_id,
    })
  };
  const URL = `${ENDPOINT_ACTIVITIES}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};


/**
 * Requete le endpoint activities
 * Récupère la liste des activites
 * @param param0
 */
const exportActivities = async ({
  accessToken,
  from_date,to_date,activity_types,
  directions_ops,hubs_ops,directions_hr,hubs_hr,
  collaborators,skills,functions,billing_customers,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  file_type,
  file_format,
}:I_EXPORT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - activities - export...'));
  const options = getFetchGETOptions({accessToken});
  const paramFromDate = `from_date=${from_date}`;
  const paramToDate = `to_date=${to_date}`;
  const paramActivityTypes = activity_types ? `activity_types=${activity_types}` : '';
  const paramDirectionsOps = directions_ops ? `directions_ops=${directions_ops}` : '';
  const paramHubsOps = hubs_ops ? `hubs_ops=${hubs_ops}` : '';
  const paramDirectionsHr = directions_hr ? `directions_hr=${directions_hr}` : '';
  const paramHubsHr = hubs_hr ? `hubs_hr=${hubs_hr}` : '';
  const paramCollaborators = collaborators ? `collaborators=${collaborators}` : '';
  const paramSkills = skills ? `skills=${skills}` : '';
  const paramFunctions = functions ? `functions=${functions}` : '';
  const paramBillingCustomers = billing_customers ? `billing_customers=${billing_customers}` : '';
  const paramAuditedCustomers = audited_customers ? `audited_customers=${audited_customers}` : '';
  const paramReferentials = referentials ? `referential_customers=${referentials}` : '';
  const paramReferentialTypes = referential_types ? `referential_types=${referential_types}` : '';
  const paramOFNumber = of_number ? `of_number=${of_number}` : '';
  const paramFileType = file_type ? `file_type=${file_type}` : '';
  const paramFileFormat = file_format ? `file_format=${file_format}` : '';
  const paramsAll = [
    paramFromDate,
    paramToDate,
    paramActivityTypes,
    paramDirectionsOps,
    paramHubsOps,
    paramDirectionsHr,
    paramHubsHr,
    paramCollaborators,
    paramSkills,
    paramFunctions,
    paramBillingCustomers,
    paramAuditedCustomers,
    paramReferentials,
    paramReferentialTypes,
    paramOFNumber,
    paramFileType,
    paramFileFormat,
  ].join('&');
  const URL = `${ENDPOINT_ACTIVITIES}/export${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options,APP_CONFIG.IMPORT_EXPORT_TIMEOUT);
};

const activitiesEndpoints = {
  get,
  post,
  remove,
  put,
  getItem,
  exportActivities,
};

export default activitiesEndpoints;
